import { render } from "./ProgrammeExceptionTimeCommiteeForm.vue?vue&type=template&id=436850d8"
import script from "./ProgrammeExceptionTimeCommiteeForm.vue?vue&type=script&lang=js"
export * from "./ProgrammeExceptionTimeCommiteeForm.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__